/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardComplianceControlHealthTrend {
    getFixupPrototypeFunction() { return SecurityDashboardComplianceControlHealthTrend.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardComplianceControlHealthTrend>): SecurityDashboardComplianceControlHealthTrend {
        let obj = Object.assign(new SecurityDashboardComplianceControlHealthTrend(), model);
        SecurityDashboardComplianceControlHealthTrend.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardComplianceControlHealthTrend>): SecurityDashboardComplianceControlHealthTrend {
        if (!model) return null;
        return SecurityDashboardComplianceControlHealthTrend.newInstance(<SecurityDashboardComplianceControlHealthTrend> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardComplianceControlHealthTrend) {
        if (!obj) return;

        models.SecurityDashboardComplianceControlHealthTrend.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardComplianceControlHealthTrend): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardComplianceControlHealthTrend.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.month === "string") {
            this.month = new Date(<string><any>this.month);
        }
    }

    /**
     * Control Health Month
     */
    month: Date;

    /**
     * Compliance Measured Risk Levels
     */
    measured_risk: models.ComplianceMeasuredRisk;

}
